<script setup lang="ts">
import type { NovaBoxLiveListHeaderProps } from './NovaBoxLiveListHeader.types'

withDefaults(defineProps<NovaBoxLiveListHeaderProps>(), {
  barMode: false,
  open: false,
})
</script>

<template>
  <div :class="['box-live-list-header', { 'bar-mode': barMode }, { on: open }]">
    <div class="left-side">
      <NovaIcon
        v-if="barMode && open"
        :icon="{ type: 'outline', name: 'chev-compact-left' }"
        :size="24"
      />
      <span class="label">LIVE</span>
      <NovaIcon :icon="{ type: 'outline', name: 'live' }" :size="18" />
    </div>

    <div class="right-side">
      <span class="label">On air {{ liveCount }}</span>
      <NovaIcon
        v-if="!barMode && liveCount !== 0"
        :icon="{ type: 'outline', name: 'chev-compact-bottom' }"
        :size="24"
        class="chev"
      />
      <NovaIcon
        v-if="barMode && !open && liveCount !== 0"
        :icon="{ type: 'outline', name: 'chev-compact-right' }"
        :size="24"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.box-live-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 14px;
  color: $color-white;
  background-color: $color-secondary-red-light-90;
  cursor: pointer;

  .left-side {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .right-side {
    display: flex;
    align-items: center;
    gap: 4px;

    .chev {
      transition: transform 0.2s ease-in-out;
    }
  }

  .left-side,
  .right-side {
    > .label {
      font-size: 15px;
      font-weight: 600;
      line-height: 20px;
    }
  }

  &.on {
    .right-side .chev {
      transform: rotate(180deg);
    }
  }
}
</style>
